import Tenant from "./Tenant";
import Site from "./Site";

export default class RoleSelect {
  code: string;
  displayName: string;
  tenant?: Tenant;
  site?: Site;
  constructor(code: string, displayName: string, tenant?: Tenant, site?: Site) {
    this.code = code;
    this.displayName = displayName;
    this.tenant = tenant;
    this.site = site;
  }
}